import { Layouts } from '@/data/libraries/Layouts';

import { useAppSelector } from '@/ui/store/helperRedux';
import { RootState } from '@/ui/store/store';

import { IStore } from '@/domain/interfaces/IStore';

import DefaultHeader from '@/ui/containers/Header/versions/DefaultHeader';
import ExclusiveHeader from '@/ui/containers/Header/versions/ExclusiveHeader';

interface HeaderDesktopProps {
    /** Logo de la aplicación */
    logo: string;
    /** Identifica la expansión del componente */
    isExpanded: boolean;
    /** Maneja la expansión del componente */
    handleExpand: () => void;
    /** Maneja renderizado de carrito  */
    handleShowCartModal: () => void;
    /** Maneja renderizado de login */
    handleShowLogin: () => void;
    /** Maneja renderizado de registro */
    handleShowRegister: () => void;
    /** Maneja renderizado opciones de usuario  */
    handleShowOptionsUser: () => void;
    /** Envía a Mis compras */
    goToPurchases: () => void;
}

/**
 * Componente HeaderDesktop
 * 
 * Este componente representa el encabezado de la versión de escritorio de la aplicación.
 * 
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.LOGO - URL de la imagen del logo.
 * @param {boolean} props.isExpanded - Indica si el campo de búsqueda está expandido.
 * @param {Function} props.handleExpand - Función para manejar la expansión del campo de búsqueda.
 * @param {Function} props.goToPurchases - Función para navegar a la página de compras.
 * @param {Function} props.handleShowCartModal - Función para mostrar el modal del carrito de compras.
 * @param {Function} props.handleShowLogin - Función para mostrar el modal de inicio de sesión.
 * @param {Function} props.handleShowRegister - Función para mostrar el modal de registro.
 * @param {Function} props.handleShowOptionsUser - Función para mostrar las opciones del usuario.
 * 
 * @returns {JSX.Element} - Retorna el componente HeaderDesktop.
 */
const HeaderDesktop = ({
    logo,
    isExpanded,
    handleExpand,
    handleShowCartModal,
    handleShowLogin,
    handleShowRegister,
    handleShowOptionsUser,
    goToPurchases,
}: HeaderDesktopProps): JSX.Element => {

    /** Estado Redux Tienda */
    const storeData = useAppSelector((state: RootState) => state.storeData) as IStore | null;

    return (
        <>
            {storeData?.layoutCode === Layouts.DEFAULT && (
                <DefaultHeader
                    logo={logo}
                    handleShowLogin={handleShowLogin}
                    handleShowRegister={handleShowRegister}
                    handleShowCartModal={handleShowCartModal}
                    handleShowOptionsUser={handleShowOptionsUser}
                    goToPurchases={goToPurchases}
                />
            )}
            {storeData?.layoutCode === Layouts.EXCLUSIVE && (
                <ExclusiveHeader
                    logo={logo}
                    isExpanded={isExpanded}
                    goToPurchases={goToPurchases}
                    handleExpand={handleExpand}
                    handleShowOptionsUser={handleShowOptionsUser}
                    handleShowCartModal={handleShowCartModal}
                />

            )}
        </>
    );
};

export default HeaderDesktop;